export default __webpack_public_path__ + "static/media/night_half_moon_snow.b062c49e.svg";